import React from 'react';
import NumberDisplay from './NumberDisplay';

const mockRecentResults = [
  { round: 1000, date: '2023-01-01', numbers: [1, 5, 12, 23, 34, 45, 2] },
  { round: 999, date: '2022-12-25', numbers: [3, 8, 15, 20, 30, 40, 7] },
  { round: 998, date: '2022-12-18', numbers: [2, 10, 18, 25, 33, 42, 11] },
];

const RecentResults = () => {
  return (
    <div className="recent-results-container">
      <h2>최근 당첨 번호</h2>
      {mockRecentResults.map((result) => (
        <div key={result.round} className="lotto-round-result">
          <p>
            <strong>{result.round}회</strong> ({result.date})
          </p>
          <NumberDisplay numbers={result.numbers.slice(0, 6)} />
          <span className="bonus-number">보너스: {result.numbers[6]}</span>
        </div>
      ))}
    </div>
  );
};

export default RecentResults;
